import { Injectable } from '@angular/core';
import { IToken, LocalStorageKeys, LocalStorageService } from '@adnoc/servicebox';

@Injectable()
export class TokenDataStorageService {
  constructor(private localStorageService: LocalStorageService) {}

  setToken(token: string): void {
    this.saveToken(token);
  }

  removeToken(): void {
    this.localStorageService.removeItem(LocalStorageKeys.token);
  }

  getToken(): IToken | null {
    return this.localStorageService.getItemValue(LocalStorageKeys.token);
  }

  private saveToken(token: string): void {
    this.localStorageService.setItemValue(LocalStorageKeys.token, { token });
  }
}
